/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ClassroomdisciplineSharedCompaniesQueryResponse,
  GetApiV1ClassroomdisciplineSharedCompaniesQueryParams,
  GetApiV1ClassroomdisciplineSharedCompanies401,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedCompanies.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ClassroomdisciplineSharedCompanies } from "../../clients/classPlanningSharedController/getApiV1ClassroomdisciplineSharedCompanies.ts";

export const getApiV1ClassroomdisciplineSharedCompaniesQueryKey = (
  params?: GetApiV1ClassroomdisciplineSharedCompaniesQueryParams,
) =>
  [
    { url: "/api/v1/classroomdiscipline/shared/companies" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ClassroomdisciplineSharedCompaniesQueryKey = ReturnType<
  typeof getApiV1ClassroomdisciplineSharedCompaniesQueryKey
>;

export function getApiV1ClassroomdisciplineSharedCompaniesQueryOptions(
  params?: GetApiV1ClassroomdisciplineSharedCompaniesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ClassroomdisciplineSharedCompaniesQueryKey(params);
  return queryOptions<
    GetApiV1ClassroomdisciplineSharedCompaniesQueryResponse,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedCompanies401>,
    GetApiV1ClassroomdisciplineSharedCompaniesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ClassroomdisciplineSharedCompanies(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description  **(Requer Authorization para autenticação)**
 * @summary Lookup de empresas ativas (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/shared/companies}
 */
export function useGetApiV1ClassroomdisciplineSharedCompanies<
  TData = GetApiV1ClassroomdisciplineSharedCompaniesQueryResponse,
  TQueryData = GetApiV1ClassroomdisciplineSharedCompaniesQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1ClassroomdisciplineSharedCompaniesQueryKey,
>(
  params?: GetApiV1ClassroomdisciplineSharedCompaniesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ClassroomdisciplineSharedCompaniesQueryResponse,
        ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedCompanies401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ClassroomdisciplineSharedCompaniesQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ClassroomdisciplineSharedCompaniesQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedCompanies401>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
